import { useSelector } from 'react-redux';
import {
  oneErrorOnNotOkFetchye,
  replaceDomainForCacheKey,
  useErrorOnNotOkFetchye,
} from '@americanexpress/fetchye-amex';
import { getFullOneCmsUrl } from '../selectors/moduleStateSelectors';
import { moduleName } from '../constants/moduleName';

export const advisoryOneCMSReporting = ({ key, error }) => ({
  moduleID: moduleName,
  componentID: 'advisoryOneCMSFetchye',
  fetchye: {
    url: key,
    status: error?.status,
  },
});

export const useAdvisoryOneCMS = () => {
  const url = useSelector(getFullOneCmsUrl);

  return useErrorOnNotOkFetchye(url, {
    mapKeyToCacheKey: replaceDomainForCacheKey('oneCMS'),
  }, advisoryOneCMSReporting);
};

export const useDataFromOneCMS = (key) => {
  const { data } = useAdvisoryOneCMS();
  return key?.split('.')?.reduce((remainingObj, nextKey) => remainingObj?.[nextKey], data?.body ?? {});
};

export const loadAdvisoryOneCMS = (dispatch, getState) => {
  const url = getFullOneCmsUrl(getState());

  return dispatch(oneErrorOnNotOkFetchye(url, {
    mapKeyToCacheKey: replaceDomainForCacheKey('oneCMS'),
  }, advisoryOneCMSReporting));
};
